import gql from 'graphql-tag';
import { lightUserFragment } from '../fragments/light-user.fragment';

export const getSuggestedUsersQuery = gql`
  query suggestUsers($startsWith: String!) {
    suggestUsers(startsWith: $startsWith) {
      ...lightUserFragment
    }
  }
  ${lightUserFragment}
`;
